/** Onglets du détail d'un modèle et d'une version. L'onglet actif vit dans l'URL (`?tab=`). */
export const MODEL_TABS = ['versions', 'summary', 'definition'] as const;
export type ModelTab = (typeof MODEL_TABS)[number];

export const isModelTab = (value: unknown): value is ModelTab =>
  typeof value === 'string' && (MODEL_TABS as readonly string[]).includes(value);

export const VERSION_TABS = ['summary', 'artifact'] as const;
export type VersionTab = (typeof VERSION_TABS)[number];

export const isVersionTab = (value: unknown): value is VersionTab =>
  typeof value === 'string' && (VERSION_TABS as readonly string[]).includes(value);
